import React, {useState} from 'react'

const DropDownIcons = ({dropdownItems, onSelect, selectedItem}) => {
    const [isHidden, setIsHidden] = useState('hidden');

    const handleSelectedItem = (item) => {
      handleDropdownToggle();
      onSelect(item);     
    }

    const handleDropdownToggle = () => {
        isHidden === 'hidden' ? setIsHidden('') : setIsHidden('hidden');
    }
    
  return (
    <div>
  <div className="mt-1 relative">
    <button onClick={handleDropdownToggle} type="button" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label" className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-400 placeholder-gray-500 text-gray-700 rounded-t-md focus:outline-none focus:shadow-outline-blue focus:border-gray-600 focus:z-10 sm:text-md sm:leading-5">
      <span className="flex space-x-4 mx-2 items-center">
        <span className="block text-gray-800 truncate">
        {selectedItem.icon}
        </span>
        <span className="block text-gray-800 text-sm truncate">
        {selectedItem.label && selectedItem.label.toUpperCase()}
        </span>
      </span>
      <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <svg className="h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </span>
    </button>

    <div className={`absolute mt-1 w-full z-10 rounded-md bg-white shadow-lg ${isHidden}`}>
      <ul tabIndex="-1" role="listbox" aria-labelledby="listbox-label" className="max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
        {dropdownItems.map(({label, icon}, i)=>{
            return (
              <li key={i} onClick={()=>handleSelectedItem({label, icon})} className="text-gray-700 hover:bg-slate-100 cursor-pointer select-none relative py-2 pl-3 pr-9">
                <div className="flex items-center">
                  <span className="ml-3 space-x-4 uppercase flex font-normal truncate">
                  <span>{icon}</span> <span>{label}</span>
                  </span>
                </div>
              </li>
            )
        })}

      </ul>
    </div>
  </div>
</div>
  )
}

export default DropDownIcons
